import React from 'react'
import ImageFallback from 'Components/imagefallback'
import vars from 'Consts/vars'

const Desktop = (props) => {
  return (
    <React.Fragment>
      <div className="author-card">
        <div className="author-cover-img">
          <div className="author-image-wrapper">
            <ImageFallback
              width={80}
              height={80}
              fallbackSrc={vars.imageBrokenDefault.user}
              src={props.author_image}
              className="author-image"
              alt={props.author_name}
            />
          </div>
        </div>
        <div className="author-text-wrapper">
          <p className="author-name">{props.author_name}</p>
          <p className="author-description">{props.author_description}</p>
        </div>
      </div>
      <style jsx>
        {`
          .author-card {
            display: flex;
            align-items: flex-start;
            flex-direction: row;
            font-family: Roboto, sans-serif;
          }
          .author-cover-img {
            width: 80px;
            height: 80px;
            flex-shrink: 0;
            margin-right: 24px;
          }

          .author-card p {
            margin: 0;
            word-break: break-word;
          }

          .author-card .author-image-wrapper {
            border-radius: 50%;
            height: 100%;
            width: 100%;
            background-color: #efefef;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow-x: auto;
            flex-shrink: 0;
          }

          .author-card .author-image {
            max-width: 100%;
            max-height: 100%;
          }

          .author-card .author-text-wrapper {
            max-width: calc(100% - 104px);
          }

          .author-card .author-name {
            font-family: Josefin Sans, sans-serif;
            font-weight: 600;
            font-size: 24px;
            line-height: 32px;
            letter-spacing: -5%;
            margin: 0;
            color: #000;
          }

          .author-card .author-description {
            font-size: 16px;
            line-height: 24px;
            color: #454f5b;
            margin: 5px 0;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default Desktop
